/**
 * @author alteredq / http://alteredqualia.com/
 *
 * Full-screen textured quad shader
 */

import { Vector2, Color } from "three";

var outlineShader = {
  uniforms: {
    tDiffuse: { value: null },
    screenSize: { value: new Vector2(1024.0, 1024.0) },
    outlineColor: { value: new Color(0.0, 1.0, 1.0) },
  },

  vertexShader: [
    "varying vec2 vUv;",

    "void main() {",

    "	vUv = uv;",
    "	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",

    "}",
  ].join("\n"),

  fragmentShader: [
    "uniform vec2 screenSize;",
    "uniform sampler2D tDiffuse;",
    "uniform vec3 outlineColor;",

    "varying vec2 vUv;",

    "void main() {",
    "float accum = 0.0;",
    "float width = 0.5;\n",
    "vec2 uvOffset = width / screenSize;",
    "accum += texture2D(tDiffuse, vUv + vec2(-uvOffset.x, uvOffset.y)).x * 0.077847;\n",
    "accum += texture2D(tDiffuse, vUv + vec2(-uvOffset.x, 0)).x * 0.123317;\n",
    "accum += texture2D(tDiffuse, vUv + vec2(-uvOffset.x, -uvOffset.y)).x * 0.077847;\n",
    "accum += texture2D(tDiffuse, vUv + vec2(0, uvOffset.y)).x * 0.123317;\n",
    "accum += texture2D(tDiffuse, vUv + vec2(0, 0)).x * 0.195346;\n",
    "accum += texture2D(tDiffuse, vUv + vec2(0, -uvOffset.y)).x * 0.123317;\n",
    "accum += texture2D(tDiffuse, vUv + vec2(uvOffset.x, uvOffset.y)).x * 0.077847;\n",
    "accum += texture2D(tDiffuse, vUv + vec2(uvOffset.x, 0)).x * 0.123317;\n",
    "accum += texture2D(tDiffuse, vUv + vec2(uvOffset.x, -uvOffset.y)).x * 0.077847;\n",
    "if (accum <= 0.0 || accum >= 0.5) discard;",
    "accum = pow(0.5 - abs(0.5 - accum), 1.2) * 3.33;",
    "gl_FragColor = vec4(outlineColor.rgb, accum);",
    "}",
  ].join("\n"),
};

export { outlineShader };
